import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgApexchartsModule } from 'ng-apexcharts';
import { HeaderComponent } from '@shared/component/layout/header/header.component';
import { SidebarComponent } from '@shared/component/layout/sidebar/sidebar.component';
import { LayoutComponent } from '@shared/component/layout/layout.component';
import { SpinnerComponent } from '@shared/component/layout/spinner/spinner.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BreadcrumbComponent } from './component/basic/breadcrumb/breadcrumb.component';
import { CheckboxComponent } from './component/basic/checkbox/checkbox.component';
import { TextFieldComponent } from './component/basic/text-field/text-field.component';
import { AccordionComponent } from './component/basic/accordion/accordion.component';
import { AlertComponent } from './component/basic/alert/alert.component';
import { BadgeComponent } from './component/basic/badge/badge.component';
import { DatePickerComponent } from './component/basic/date-picker/date-picker.component';
import { DropdownComponent } from './component/basic/dropdown/dropdown.component';
import { EmptyStateComponent } from './component/basic/empty-state/empty-state.component';
import { ModalComponent } from './component/basic/modal/modal.component';
import { RadioButtonComponent } from './component/basic/radio-button/radio-button.component';
import { TabComponent } from './component/basic/tab/tab.component';
import { TextAreaComponent } from './component/basic/text-area/text-area.component';
import { TextEditorComponent } from './component/basic/text-editor/text-editor.component';
import { ToastrComponent } from './component/basic/toastr/toastr.component';
import { ToggleComponent } from './component/basic/toggle/toggle.component';
import { TooltipComponent } from './component/basic/tooltip/tooltip.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxEditorModule } from 'ngx-editor';
import { ButtonComponent } from './component/basic/button/button.component';
import { OptionButtonComponent } from './component/basic/option-button/option-button.component';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { MultiDropdownComponent } from './component/basic/multi-dropdown/multi-dropdown.component';
import { TooltipModule } from 'primeng/tooltip';
import { CheckboxModule } from 'primeng/checkbox';
import { CalendarModule } from 'primeng/calendar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { InputGroupModule } from 'primeng/inputgroup';
import { PaginatorModule } from 'primeng/paginator';
import { MultiSelectModule } from 'primeng/multiselect';
import { NoSpaceDirective } from './directives/no-space.directive';
import { OnlyNumberDirective } from './directives/only-number.directive';
import { InputSwitchModule } from 'primeng/inputswitch';
import { CustomDateTimePickerComponent } from './component/basic/custom-datetime-picker/custom-datetime-picker.component';
import { FileUploadComponent } from './component/basic/file-upload/file-upload.component';
import { DataTableComponent } from './component/advance/data-table/data-table.component';
import { DonutComponent } from './component/advance/graph/donut/donut.component';

@NgModule({
  declarations: [
    HeaderComponent,
    SidebarComponent,
    LayoutComponent,
    SpinnerComponent,
    AccordionComponent,
    AlertComponent,
    BadgeComponent,
    BreadcrumbComponent,
    ButtonComponent,
    OptionButtonComponent,
    CheckboxComponent,
    DatePickerComponent,
    DropdownComponent,
    EmptyStateComponent,
    FileUploadComponent,
    DataTableComponent,
    DonutComponent,
    ModalComponent,
    RadioButtonComponent,
    TabComponent,
    TextAreaComponent,
    TextEditorComponent,
    TextFieldComponent,
    ToastrComponent,
    ToggleComponent,
    TooltipComponent,
    MultiDropdownComponent,
    CustomDateTimePickerComponent,
    FileUploadComponent,
    CustomDateTimePickerComponent,
    NoSpaceDirective,
    OnlyNumberDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgApexchartsModule,
    RouterModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgxEditorModule,
    ButtonModule,
    TableModule,
    TooltipModule,
    CheckboxModule,
    CalendarModule,
    MatIconModule,
    MatDialogModule,
    MatSnackBarModule,
    DropdownModule,
    ButtonModule,
    InputTextModule,
    InputGroupModule,
    PaginatorModule,
    InputSwitchModule,
    MultiSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatRadioModule,
    MatTooltipModule
  ],
  providers: [],
  exports: [
    SpinnerComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CustomDateTimePickerComponent,
    RouterModule,
    SpinnerComponent,
    TooltipModule,
    CheckboxModule,
    CalendarModule,
    InputSwitchModule,
    NgSelectModule,
    AccordionComponent,
    AlertComponent,
    BadgeComponent,
    BreadcrumbComponent,
    ButtonComponent,
    OptionButtonComponent,
    CheckboxComponent,
    DatePickerComponent,
    DropdownComponent,
    EmptyStateComponent,
    FileUploadComponent,
    ModalComponent,
    RadioButtonComponent,
    TabComponent,
    TextAreaComponent,
    TextEditorComponent,
    TextFieldComponent,
    ToastrComponent,
    ToggleComponent,
    TooltipComponent,
    MultiDropdownComponent,
    DropdownModule,
    MatIconModule,
    MatSelectModule,
    MatOptionModule,
    MatRadioModule,
    MatTooltipModule,
    DataTableComponent,
    DonutComponent,
    NoSpaceDirective,
    OnlyNumberDirective,
    NgApexchartsModule,
    MatDialogModule
  ]
})
export class SharedModule { }